import { createSelector } from 'reselect';

import { IAddressProps, selectAddressParamsMemoize } from '@r1-frontend/entities/ContactAddress/selectors/selectAddressParams';
import { selectIsPhoneConfirmed } from '@r1-frontend/entities/ContactDetail/selectors/selectIsPhoneConfirmed';

import { IFlow, TUnifiedAddressData } from '~/src/features/full-buy/store/initialState';
import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import { IFullBuyTariff } from '~/src/features/full-buy/store/tariffTransformer';
import { TProduct } from '~/src/features/full-buy/store/transformShopItem';
import { TState } from '~/src/store';
import { selectDomain } from '~/src/store/selectors/domain';

export interface IDataForAgreement {
    domain: string,
    tariffPackage: IFullBuyTariff | null,
    addressParams: IAddressProps | null,
    isPhoneConfirmed: boolean,
    providerId: number,
    isHouseConnected: boolean,
    gigabitAvail: number,
    fio: string,
    phone: string,
    products: TProduct[],
    promoCode: string,
    flow: IFlow | null,
    selectedSubscriptions: number[],
    unifiedSelectedAddress: TUnifiedAddressData,
}

/**
 * Селектор выбирает данные для функции создания договора
 */
export const selectDataForCreateAgreement = createSelector(
    [
        (state: TState) => state,
    ],
    (state: TState): IDataForAgreement => ({
        domain: selectDomain(state),
        tariffPackage: selectCurrentTariff(state),
        addressParams: selectAddressParamsMemoize(state),
        isPhoneConfirmed: selectIsPhoneConfirmed(state),
        providerId: state.city.provider.providerId,
        isHouseConnected: state.contactAddress.verifiedAddressData.isHouseConnected,
        gigabitAvail: state.contactAddress.verifiedAddressData.gigabitAvail,
        fio: state.contactDetails.editedFio,
        phone: state.contactDetails.confirmedPhone.phone,
        products: state.fullBuy.products,
        promoCode: state.fullBuy.promoCode?.value || '',
        flow: state.fullBuy.flow,
        selectedSubscriptions: state.fullBuy.selectedSubscriptions,
        unifiedSelectedAddress: state.fullBuy.selectedAddress!,
    }),
);
